import React from 'react';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { ComparePlan } from '../CompareTable/useCompareTable';

interface Props {
  label: string;
  planIds: string[];
  comparedPlans: ComparePlan[];
  valueKey: keyof ComparePlan;
  spouseValueKey?: keyof ComparePlan;
  children(v: any, s?: any): React.ReactElement;
}

export const TableRow: React.FC<Props> = ({
  label,
  planIds,
  comparedPlans,
  valueKey,
  spouseValueKey,
  children,
}) => {
  return (
    <Box as="tr">
      <Box as="td" p="16">
        <Text fontWeight={500}>{label}</Text>
      </Box>

      {planIds.map((planId, index) => {
        const planData = comparedPlans[index];

        if (!planData) {
          return null;
        }

        return (
          <Box key={`${valueKey}-${planId}`} as="td" p="16">
            {children(planData[valueKey], spouseValueKey && planData[spouseValueKey])}
          </Box>
        );
      })}
    </Box>
  );
};
